import NextHomeSignInPage from './NextHomeSignInPage';
import authRoles from '../../auth/authRoles';

const NextHomeSignInConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.AllUsers,
  routes: [
    {
      path: 'nexthome',
      element: <NextHomeSignInPage />,
    },
  ],
};

export default NextHomeSignInConfig;
